import React from 'react';
import PlatformPage from './PlatformPage';
import { getPlatformBySlug } from './platformData';

export default function Telegram() {
  const platform = getPlatformBySlug('telegram');
  if (!platform) return <div>Platform not found</div>;

  return (
    <PlatformPage
      platformName={platform.name}
      platformSlug={platform.slug}
      tagline={platform.tagline}
      description={platform.description}
      features={platform.features}
      benefits={platform.benefits}
      logoSrc={platform.logo}
      accentColor={platform.accentColor}
    />
  );
}
